export const MESSAGES = {
  REQUEST_ERROR: "Fail to fetch attendance history",
  NO_REQUESTS_AVAILABLE: "No Attendance History",
  SITES_NAME_REQUIRED: "Site name is required",
  SITE_SELECTION_REQUIRED: "Site selection is required",
  DATE_REQUIRED: "Date is required",
  TIME_REQUIRED: "Time is required",
  FUTURE_DATE_ERROR: "Date cannot be today or in the future",
  INVALID_SITE_ERROR: "Site boundary is invalid or not loaded.",
  LOCATION_DENIED_ERROR: "Cannot get location",
  SELFIE_REQUIRED: "Please take a selfie before submitting.",
  NOT_IN_SITE: "You are not within the selected site's geofence.",
  NOT_IN_SITE_RETRY: "You are not within the selected site's geofence. Kindly Retry..!",
  SUBMITTED_ATTENDANCE: (time) => `Attendance Submitted on ${time}` ,
  FAILED_SUBMISSION: "Failed to submit attendance.",
  SITES_ERROR: "Error fetching sites",
  LOCATION_NOT_AVAILABLE: "Location Not available.",
  PHOTO_NOT_AVAILABLE: "Photo Not available",
  MAP_LOADING_ERROR: "Error Loading Map",
  ATTENDANCE_ALREADY_EXISTS_RANGE: (inTime, outTime) =>
    `Attendance already exists for this date from ${inTime} to ${outTime}`,
  ATTENDANCE_ALREADY_EXISTS_CHECKIN: (inTime) =>
    `Attendance already exists for this date at ${inTime}`,
  LOCATION_REQUIRED: "Location Not available. Please enable GPS and retry again.",
  PREVIOUS_DAY_CHECKOUT_MISSING:
    "You cannot check in today because your last working day's check-out is missing.",
  BACKDATED_NOT_APPROVED:
    "You are not approved by HR to submit backdated attendance for this date.",
  REMARKS_REQUIRED:
    "Please mention a reason for marking attendance without a site.",
};

export const ATTENDANCE_COLUMNS = [
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ATTENDANCE_LABELS = {
  "site_name": "Site",
  "date": "Date",
  "checkin_time": "Check-in Time",
  "checkout_time": "Check-out Time",
  "is_backdated": "Backdated",
  "status": "Approval Status",
  "actions": "Actions"
};

export const ATTENDANCE_TYPES = {
  "CHECKIN": 'checkin',
  "CHECKOUT": 'checkout',
};

export const ADMIN_ATTENDANCE_TABLE_COLUMNS = [
  "user_name",
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ADMIN_ATTENDANCE_COLUMN_LABELS = {
  user_name: "User",
  site_name: "Site",
  date: "Date",
  checkin_time: "Check-In Time",
  checkout_time: "Check-Out Time",
  is_backdated: "Backdated",
  status: "Status",
  actions: "Actions",
};

export const EXCEL_FILE_COLUMNS = [
  { label: "Site Name", value: "site_name" },
  { label: "User Name", value: "user_name" },
  { label: "Date", value: "date" },
  { label: "Check-In Time", value: "checkin_time" },
  { label: "Check-Out Time", value: "checkout_time" },
  { label: "Is Backdated", value: "is_backdated" },
  { label: "Status", value: "status" },
  { label: "Check IN Photo", value: "checkin_photo_url" },
  { label: "Check OUT Photo", value: "checkout_photo_url" },
  { label: "Remarks (No Site)", value: "remarks" },
]


export const ACTION_APPROVED = "approved";
export const ACTION_REJECTED = "rejected";

export const APPROVED = "APPROVED";
export const AUTO_APPROVED = "AUTO_APPROVED";
export const REJECTED = "REJECTED";
export const PENDING = "PENDING";
export const IN_PROGRESS = "IN_PROGRESS";
export const PENDING_L1_APPROVAL = "PENDING_L1_APPROVAL";
export const PENDING_L2_APPROVAL = "PENDING_L2_APPROVAL";
export const CORRECTED = "CORRECTED";

export const FILTER_FILEDS = ["status", "date"]
export const ATTENDANCE_ERROR = "Failed to fetch attendance data"
export const USERDATA_ERROR = "Failed to fetch user data"
export const ATTENDANCE_STATUS_ERROR = "Failed to update attendance status"
export const TASK_ERROR = "Failed to fetch task data"
export const TASK_WARNING = "Task not assigned for today"
export const INCOMPLETE_TASK_WARNING = "Assigned Task not completed"

export const getStatusBadgeClasses = (status) => {
  switch (status) {
    case APPROVED:
      return "bg-green-100 text-green-700";

    case AUTO_APPROVED:
      return "bg-emerald-100 text-emerald-700";

    case REJECTED:
      return "bg-red-100 text-red-700";

    case PENDING_L1_APPROVAL:
      return "bg-yellow-100 text-yellow-700";

    case PENDING_L2_APPROVAL:
      return "bg-orange-100 text-orange-700";

    case CORRECTED:
      return "bg-blue-100 text-blue-700";

    default:
      return "bg-gray-100 text-gray-600";
  }
};
